import ProductCard from './ProductCard';
import { Skeleton } from '@/components/ui/skeleton';

export const ProductGrid = ({ products: rawProducts, loading = false }) => {
  const products = Array.isArray(rawProducts) ? rawProducts : [];
  if (loading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
        {[...Array(10)].map((_, i) => (
          <div 
            key={i} 
            className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden animate-fade-in"
            style={{ animationDelay: `${i * 50}ms` }}
          >
            <Skeleton className="aspect-square w-full" />
            <div className="p-4 space-y-3">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-6 w-1/2" />
              <Skeleton className="h-12 w-full rounded-xl" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-20 h-20 mx-auto mb-4 bg-slate-100 rounded-full flex items-center justify-center">
          <span className="text-4xl">📦</span>
        </div>
        <p className="text-slate-500 text-lg font-medium">Nenhum produto encontrado.</p>
        <p className="text-slate-400 text-sm mt-1">Tente buscar por outra categoria.</p>
      </div>
    );
  }

  return (
    <div 
      className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6"
      data-testid="product-grid"
    >
      {products.map((product, index) => (
        <div 
          key={product.id} 
          className="animate-fade-in"
          style={{ 
            animationDelay: `${index * 50}ms`,
            animationFillMode: 'both'
          }}
        >
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};

export default ProductGrid;
